<script lang="ts">
	import { useDialog } from "@components/utils/useDialog";
	import {
		locationQuery,
		locationInputQuery,
		query
	} from "@stores/searchQuery";
	import { useAlgoliaClient } from "@stores/algolia";
	import { capitalizeFirstLetter } from "@utils/capitalizeFirstLetter.js";

	const { props, close } = useDialog();

	const { performSearch, fetchLocation } = useAlgoliaClient();

	$: label = $props?.result[0];
</script>

<div class="daisy-modal-box bg-white">
	{#if $locationQuery}
		Je locatie staat momenteel ingesteld op <span class="font-bold">
			{$locationQuery}</span
		>, wil je deze wijzigen naar <span class="font-bold">{label}</span>?
	{:else}
		Je locatie is momenteel nog niet ingesteld. Wil je deze op <span
			class="font-bold"
		>
			{label}</span
		> zetten?
	{/if}
	<div class="modal-action mt-4 flex justify-end gap-2">
		<button
			on:click={() => {
				close();
				performSearch({
					checkForLocationInQueryString: false
				});
			}}
			class="min-w-16 rounded-lg p-3 font-bold text-black outline-none"
			>Nee</button
		>
		<button
			on:click={async () => {
				await fetchLocation(label);

				$query = capitalizeFirstLetter(
					$query.replace($props?.needle, " ").trim()
				);

				performSearch({
					checkForLocationInQueryString: false
				});
				close();

				$locationQuery = $props?.result[0];
				$locationInputQuery = $props?.result[0];
			}}
			class="bg-primary min-w-16 rounded-lg p-3 font-bold text-white">Ja</button
		>
	</div>
</div>
<form method="dialog" class="daisy-modal-backdrop">
	<button>close</button>
</form>
